'use client';

import { useEffect } from 'react';
// eslint-disable-next-line no-restricted-imports
import { useSession, signOut } from 'next-auth/react';
import posthog from 'posthog-js';

type LoginErrorHandlerProps = {
  error?: string;
};

/**
 * Handles sign out when user is authenticated but access is denied.
 * This happens when a user successfully authenticates but doesn't have
 * the required group membership.
 */
export function LoginErrorHandler({ error }: LoginErrorHandlerProps) {
  const { data: session } = useSession();

  useEffect(() => {
    // If there's an access denied error and user is still signed in, sign them out
    if (error === 'AccessDenied' && session) {
      posthog.capture('auth:login_denied', { reason: 'access_denied' }, { send_instantly: true });
      signOut({ redirect: false });
    }
  }, [error, session]);

  return <></>;
}
